import logo from './logo.svg';
import './App.css';
import Amino from './components/Amino';

function App() {
  return (
    
    <div className="App">
      <Amino></Amino>
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
      </header>
    </div>
  );
}

export default App;
